<div>
  <h3>
    {{ 'cancel-rolling-trial-subscription-title' | translate }}
  </h3>
  <p [innerHTML]="'cancel-rolling-trial-subscription-message' | tmd"></p>
</div>
